import BedTime from './BedTime';

export default BedTime;
